// Central bilingual dictionary for Hawkam
export const dict = {
  brand: { ar: "حوكم", en: "HAWKAM" },
  brandSub: { ar: "استشارات حوكمة وامتثال", en: "Governance & Compliance Consulting" },
  nav: {
    home: { ar: "الرئيسية", en: "Home" },
    about: { ar: "من نحن", en: "About" },
    services: { ar: "الخدمات", en: "Services" },
    campaigns: { ar: "الحملات", en: "Campaigns" },
    packages: { ar: "الباقات", en: "Packages" },
    articles: { ar: "المكتبة", en: "Library" },
    training: { ar: "التدريب", en: "Training" },
    news: { ar: "الأخبار", en: "News" },
    policies: { ar: "الحوكمة الذاتية", en: "Governance" },
    contact: { ar: "تواصل", en: "Contact" },
    assessment: { ar: "تقييم الحوكمة", en: "Assessment" },
    quote: { ar: "طلب عرض سعر", en: "Get a Quote" },
    admin: { ar: "لوحة التحكم", en: "Admin" },
  },
  hero: {
    tagline: { ar: "الحوكمة كأسلوب حياة مؤسسي", en: "Governance as an Institutional Way of Life" },
    title: {
      ar: "نصمّم أنظمة حوكمة تُثمر ثقةً واستدامة",
      en: "We design governance systems that build trust and sustainability.",
    },
    subtitle: {
      ar: "منصة متخصصة في تصميم أطر الحوكمة والامتثال وإدارة المخاطر، لمساعدة المؤسسات على بناء ممارسات أكثر ثقة واستدامة في عالم متغير.",
      en: "A specialized platform for governance, compliance, and risk management, helping organizations build more trusted and sustainable practices in a changing world.",
    },
    cta1: { ar: "ابدأ التقييم", en: "Begin Assessment" },
    cta2: { ar: "استكشف الخدمات", en: "Explore Services" },
    activityTitle: { ar: "مؤشرات نشاط المنصة", en: "Platform Activity" },
  },
  home: {
    valuesTitle: { ar: "لماذا Hawkam؟", en: "Why Hawkam" },
    valuesSubtitle: {
      ar: "منظومة عمل تجمع بين خبرة إقليمية عميقة وممارسات حوكمة عالمية.",
      en: "A practice fusing deep regional insight with globally certified governance craft.",
    },
    servicesTitle: { ar: "الخدمات الاستشارية", en: "Advisory Practices" },
    servicesSubtitle: {
      ar: "خدمات مصمّمة بمعايير المؤسسات الفاخرة.",
      en: "Disciplines delivered to institutional-grade standards.",
    },
    campaignsTitle: { ar: "حملات محدودة العدد", en: "Limited-Slot Cohorts" },
    campaignsSubtitle: { ar: "مبادرات متخصصة في الحوكمة والامتثال.", en: "Exclusive seats for focused programmes." },
    articlesTitle: { ar: "من المكتبة", en: "From the Library" },
    testimonialsTitle: { ar: "شهادات عملائنا", en: "What Our Partners Say" },
    ctaTitle: { ar: "جاهز لبناء منظومة حوكمة تُحدث فرقاً؟", en: "Ready to build governance that moves the needle?" },
    ctaSub: { ar: "احجز استشارتك الأولى مجاناً.", en: "Book a complimentary discovery call." },
  },
  about: {
    heading: { ar: "من نحن", en: "About Us" },
    vision: { ar: "الرؤية", en: "Vision" },
    visionBody: {
      ar: "أن نكون المرجعية الأولى في المنطقة لتصميم أُطر الحوكمة الذكية.",
      en: "To become the region's benchmark for engineering intelligent governance frameworks.",
    },
    mission: { ar: "الرسالة", en: "Mission" },
    missionBody: {
      ar: "نُمكّن المؤسسات من بناء حوكمة عملية، قابلة للقياس، ومتوافقة مع المعايير الدولية.",
      en: "Empower institutions with pragmatic, measurable governance aligned to international standards.",
    },
    values: { ar: "قيمنا", en: "Values" },
    v1: { ar: "النزاهة", en: "Integrity" },
    v2: { ar: "الدقة", en: "Precision" },
    v3: { ar: "الشراكة", en: "Partnership" },
    v4: { ar: "الأثر", en: "Impact" },
    team: { ar: "الفريق التنفيذي", en: "Executive Team" },
  },
  common: {
    submit: { ar: "إرسال", en: "Submit" },
    send: { ar: "إرسال", en: "Send" },
    next: { ar: "التالي", en: "Next" },
    back: { ar: "السابق", en: "Back" },
    readMore: { ar: "اقرأ المزيد", en: "Read more" },
    slotsLeft: { ar: "مقاعد متبقية", en: "seats left" },
    name: { ar: "الاسم", en: "Name" },
    email: { ar: "البريد الإلكتروني", en: "Email" },
    phone: { ar: "الهاتف", en: "Phone" },
    company: { ar: "الجهة / الشركة", en: "Company" },
    message: { ar: "الرسالة", en: "Message" },
    subject: { ar: "الموضوع", en: "Subject" },
    service: { ar: "الخدمة المطلوبة", en: "Service Interest" },
    budget: { ar: "الميزانية التقديرية", en: "Estimated Budget" },
    consent: {
      ar: "أوافق على معالجة بياناتي وفق سياسة الخصوصية.",
      en: "I consent to my data being processed per the Privacy Policy.",
    },
    thankYou: { ar: "تم الاستلام. سيتواصل فريقنا معك.", en: "Received. Our team will be in touch." },
    error: { ar: "حدث خطأ. حاول مرة أخرى.", en: "Something went wrong. Please try again." },
    apply: { ar: "قدّم طلبك", en: "Apply now" },
    filled: { ar: "مكتمل", en: "Filled" },
    version: { ar: "الإصدار", en: "Version" },
    download: { ar: "تنزيل", en: "Download" },
  },
  consent: {
    banner: {
      ar: "باستخدامك لمنصة Hawkam، فإنك توافق على شروط الاستخدام وسياسة الخصوصية.",
      en: "By using the Hawkam platform, you accept our Terms of Use and Privacy Policy.",
    },
    accept: { ar: "أوافق", en: "I Accept" },
    review: { ar: "مراجعة", en: "Review" },
  },
};

export function t(dictNode, lang) {
  if (!dictNode) return "";
  if (typeof dictNode === "string") return dictNode;
  return dictNode[lang] ?? dictNode.en ?? "";
}
